
import React from "react";
import { TabsContent } from "@/components/ui/tabs";
import AdminDashboard from "@/components/admin/dashboard/AdminDashboard";
import ProviderDashboard from "@/components/admin/dashboard/ProviderDashboard";
import { StrategyWithDetails, StrategyProvider, StrategyPerformance, Account } from "@/types/strategy-types";

interface DashboardTabProps {
  users: any[];
  strategies: StrategyWithDetails[];
  providers: StrategyProvider[];
  accountPerformances: StrategyPerformance[];
  accounts: Account[];
  leadAccounts: any[];
  stripeSubscriptions: {
    monthly: number;
    yearly: number;
    total: number;
    activeCanceled: number;
    subscriptions: any[];
  };
  userRole: string | null;
}

const DashboardTab = ({ 
  users, 
  strategies, 
  providers, 
  accountPerformances, 
  accounts,
  leadAccounts,
  stripeSubscriptions,
  userRole
}: DashboardTabProps) => {
  return (
    <TabsContent value="dashboard">
      {userRole === 'strategy_provider' ? (
        <ProviderDashboard 
          strategies={strategies as any} 
          accountPerformances={accountPerformances}
          accounts={accounts}
        />
      ) : (
        <AdminDashboard 
          users={users} 
          strategies={strategies as any} 
          providers={providers}
          accountPerformances={accountPerformances}
          accounts={accounts}
          leadAccounts={leadAccounts}
          stripeSubscriptions={stripeSubscriptions}
        />
      )}
    </TabsContent>
  );
};

export default DashboardTab;
